import { render, staticRenderFns } from "./TGModal.vue?vue&type=template&id=eb2a7e2a&scoped=true&"
import script from "./TGModal.vue?vue&type=script&lang=js&"
export * from "./TGModal.vue?vue&type=script&lang=js&"
import style0 from "./TGModal.vue?vue&type=style&index=0&id=eb2a7e2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2a7e2a",
  null
  
)

export default component.exports